import moment from "moment";
import React, { useState } from "react";
import { List, ListInlineItem } from "react-feather";
import { Col, Input, Modal, ModalBody, Row } from "reactstrap";
import Title from "../../../../components/title";
import { ComonIcons } from "../../../../contents/commonIcons";
import { setShowDeletedMemberModal } from "../../../../redux/actions/member/memberAction";
import { useDispatch, useSelector } from "react-redux";
import {
  createGymMember,
  undoDeletionMemberApi,
} from "../../../../redux/actions/api/apiAction";
import SpinnerComponent from "../../../../components/spinner/spinner";

export const DeletedMemberModal = ({}) => {
  const dispatch = useDispatch();
  const { existingMember, deletedMemberModal } = useSelector(
    (state) => state.member
  );
  const { gym } = useSelector((state) => state.gym);
  const { RFIDCardId } = useSelector((state) => state.membershipCard);
  console.log({ deletedMemberModal });
  const undoDeletionMember = () => {
    dispatch(undoDeletionMemberApi(existingMember.id));
  };
  const toggle = () => {
    dispatch(setShowDeletedMemberModal(!deletedMemberModal));
  };

  const { loading } = useSelector((state) => state.gym);

  if (loading)
    return (
      <div
        style={{ height: "800px" }}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <SpinnerComponent />
        <h3>Please wait</h3>
      </div>
    );
  return (
    <>
      <Modal
        isOpen={deletedMemberModal}
        toggle={toggle}
        centered={true}
        size="lg"
        className="large-pop adding-popup "
      >
        <ModalBody>
          <div className="bg-white mx-2">
            <div className="d-flex align-items-center border-bottom-1 pb-4">
              <div className="d-inline-flex ">
                <Title
                  title=" Member Details  "
                  subtitlestyle="ctf-tx-secondary"
                />
              </div>
              <div className="d-inline-flex ml-auto">
                <div className="close-icons pb-0">
                  <div className="text-right">
                    <span
                      className="svg-block"
                      onClick={() => {
                        toggle();
                      }}
                    >
                      {ComonIcons.closeBlack}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {console.log({ existingMember })}{" "}
            <Row className="mt-3 mb-4">
              <Col md={12}>
                <div className="alert alert-warning">
                  <strong>Note:</strong>
                  {`  The Using Email ${existingMember?.email}/Phone ${existingMember?.phone} was Assigned to a deleted member who  was deleted by  `}
                  <strong>
                    {existingMember?.deletedDate?.deletedBy?.name || "Unknown"}
                  </strong>{" "}
                  on{" "}
                  <strong>
                    {moment(existingMember?.deletedDate?.updatedAt).format(
                      "MMMM Do YYYY, h:mm A"
                    )}
                  </strong>
                  .
                </div>
              </Col>
            </Row>
            <Row className="mb-4 mt-4">
              <Col md={3} className="ml-3">
                <span className="note-details member-info-bold">
                  First Name
                </span>
              </Col>
              <Col md={3}>
                <span className="note-details member-info-bold">Last Name</span>
              </Col>
              <Col md={3}>
                <span className="note-details member-info-bold">
                  {existingMember.phone ? "phone" : "email"}
                </span>
              </Col>
            </Row>
            <Row className="mb-4 mt-4">
              <Col md={3} className="ml-3">
                <span className="note-details">
                  {existingMember?.firstName}
                </span>
              </Col>
              <Col md={3}>
                <span className="note-details">{existingMember?.lastName}</span>
              </Col>
              <Col md={3}>
                <span className="note-details">
                  {existingMember.phone
                    ? existingMember.phone
                    : existingMember.email}
                </span>
              </Col>
            </Row>
            <Row className="mx-0 w-100">
              <Col md={12} className="px-0">
                <div className="action-wrapper blk-padding-y d-flex justify-content-between minimize-btns">
                  <div className="action-inner-block d-flex justify-content-between w-100">
                    <React.Fragment>
                      <button
                        type="button"
                        className="btn btn-medium btn-transparent mr-4"
                        onClick={() => {
                          toggle();
                        }}
                      >
                        Cancel
                      </button>
                    </React.Fragment>
                    <button
                      className="btn btn-medium min-width-210"
                      type="button"
                      onClick={() => {
                        undoDeletionMember();
                      }}
                    >
                      Undo Deletion Member{" "}
                    </button>{" "}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default DeletedMemberModal;
